import { GUIDE_SURFACES } from '@features/knowledge-base/constants/featureLinks';
import { useFeatureLinksAccess } from '@features/knowledge-base/hooks/useFeatureLinksAccess';
import { useGuideDrawer } from '@features/knowledge-base/hooks/useGuideDrawer';

/** The controller supplies a validated /kb/{topic}/{id} path. */
export function usePulseReader() {
  const { enabled } = useFeatureLinksAccess({ logExposure: false });
  const drawer = useGuideDrawer();
  return {
    enabled,
    openReader: (path: string) => {
      if (enabled)
        drawer.open({ slug: path.slice('/kb/'.length), surfaceId: GUIDE_SURFACES.PULSE });
    },
  };
}
